export default __webpack_public_path__ + "static/media/netball-icon.818ae3be.svg";